import { MockFactory } from '@tino-frontend/mocks'
import { LimitReservationsResponse } from '@types'

export const limitReservationsMock = new MockFactory<LimitReservationsResponse>(
  {
    total: 50,
  }
)
